import styled from 'styled-components/macro';
import trim from "../utils/trim";
import {themecolors} from "../utils/themecolors";

const Container = styled.div``;
const Heading = styled.div``;
const Description = styled.div``;
const Image = styled.div``;
const Text = styled.div``;
const Domain = styled.div``;
const Footer = styled.div``;

const LinkExcerpt = styled(({className, data, domain}) => {
    return (
        <Container className={className}>
            {data.large_image &&
            <Image>
                <img
                    src={`https://media.scored.co/link/${data.large_image}`}/>
            </Image>
            }
            <Text>
                <Heading>
                    {trim(data.title, 128)}
                </Heading>
                {data.description.trim() &&
                    <Description>
                        {trim(data.description, 256)}
                    </Description>
                }
                <Footer>
                    <Domain>
                        {domain || ''}
                    </Domain>
                </Footer>
            </Text>
        </Container>
    );
})`

  background-color: ${({theme}) => theme.color.name === 'dark' ? 'none' : 'initial'};
  border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : '#dddddd'};
  border-radius: 8px;
  margin: 0 8px;

  ${Footer} {
    display: flex;
    align-items: center;
  }
  ${Footer} a {
    margin-left: auto;
  }
  ${Text} {
    padding: 12px;
  }
  ${Heading} {
    margin-top: 4px;
    font-weight: 600;
  }
  ${Description} {
    margin-top: 8px;
    font-size: 14px;
  }

  ${Image} {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100%;
    height: 200px;
    flex-shrink: 0;
  }
  ${Image} img {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 200px;
    object-fit: cover;
    width: 100%;
  }
  ${Domain} {
    margin-top: 8px;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? 'rgba(255,255,255,.6)' : themecolors.light_medium_impact_text};
  }


  @media only screen and (max-width: 780px) {
    & {
      margin: 0;
    }
  }
  
  @media only screen and (min-width: 1200px) {
    & {
      height: 172px;
      display: flex;
      flex-direction: row;
      background-color: initial;
    }
    ${Text} {
      display: flex;
      flex-direction: column;
    }
    ${Heading} {
      margin-top: 0;
    }
    ${Description} {
      margin-top: 4px;
    }
    ${Image}, ${Image} img {
      width: 172px;
      min-width: 172px;
      height: 170px;
      border-top-right-radius: 0;
      border-bottom-left-radius: 8px;
    }
    ${Footer} {
      margin-top: auto;
    }
  }
`;

export default LinkExcerpt;
